<div class="library-dialog">
  @if (editMode) {
  <h2 mat-dialog-title i18n>Edit Document</h2>
  } @if (!editMode) {
  <h2 mat-dialog-title i18n>Enter New Document</h2>
  }

  <mat-dialog-content>
    <form [formGroup]="form">
      <div class="dialog-fields">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label i18n="@@directory">Directory</mat-label>
          <mat-select formControlName="directory" [compareWith]="compareFn">
            <mat-option [value]="null">[.]</mat-option>
            @for (parent of (directories$ | async); track parent) {
            <mat-option [value]="parent">{{ parent.name }}</mat-option>
            }
          </mat-select>
          <button type="button" matSuffix matIconButton aria-label="Clear directory"
            (click)="form.controls.directory.setValue(null); $event.stopPropagation()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label i18n>External Id (opt.)</mat-label>
          <input matInput formControlName="externalId" />
        </mat-form-field>
        @if (config?.departmentsEnable === true && data.libraryType ===
        LibraryT.PUBLIC ) {
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label i18n="@@departments">Departments</mat-label>
          <mat-select formControlName="departmentsUuids" multiple>
            @for (department of (departments$ | async); track department) {
            <mat-option [value]="department.uuid">{{
              department.name
            }}</mat-option>
            }
          </mat-select>
          <button type="button" matSuffix matIconButton aria-label="Clear departments"
            (click)="form.controls.departmentsUuids.setValue([]); $event.stopPropagation()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        } @if (!editMode) {
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label i18n="@@fileType">File type</mat-label>
          <mat-select formControlName="type" (selectionChange)="onTypeChange()">
            @for (fileType of docTypes | keyvalue; track fileType) {
            <mat-option [value]="fileType.key">{{ fileType.value }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (form.controls.type.value !== null) {
        <input
          type="file"
          class="file-input"
          accept=".{{ docTypes[form.controls.type.value] }}"
          (change)="onFileSelected($event)"
          #fileUpload
        />
        <div class="fxFlexFill">
          <div class="file-upload">
            <div class="file-name">
              {{ fileName || "-" }}
            </div>
            @if (!uploadProgress) {
            <button
              matMiniFab
              type="button"
              aria-label="Choose file"
              color="primary"
              class="upload-btn"
              (click)="fileUpload.click()"
            >
              <mat-icon>attach_file</mat-icon>
            </button>
            }
          </div>
        </div>
        @if (uploadProgress !== null && uploadProgress !== undefined) {
        <div class="upload-progress">
          <mat-progress-bar class="progress-bar"
            mode="determinate"
            [value]="uploadProgress"
           />
          <button type="button" matIconButton aria-label="Cancel upload" (click)="cancelUpload()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        }
        } }
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label i18n>Name</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
      <button matButton="outlined" (click)="onCloseClick()" i18n="buttonClose">
        Close
      </button>
      <button
        matButton="filled"
        color="accent"
        (click)="onSave()"
        [disabled]="!form.valid || (fileName === '' && !editMode) || uploadSub != null"
        i18n="@@buttonSave"
      >
        Save
      </button>
    </mat-dialog-actions>
</div>
